module.exports = __webpack_public_path__ + "static/media/mobile3.dcecd056.png";